module.exports = __webpack_public_path__ + "static/media/ind.1be8b4df.svg";